import { downscale } from 'src/conf/scale';
import type { GachaThemeStyles } from '../gacha.theme';

/** Base path for this theme assets */
const folder = 'assets/ui/gacha/setsubun';

/** Assets for preload */
const preload = {
  gacha_button_en: `${folder}/buttons/gacha_button_en.png`,
  gacha_button_ja: `${folder}/buttons/gacha_button_ja.png`,
};

/** All assets for the theme */
const assets = {
  ...preload,
  gacha_popup: `${folder}/background/gacha_popup.png`,
  gacha_button_en: `${folder}/buttons/gacha_button_en.png`,
  gacha_button_ja: `${folder}/buttons/gacha_button_ja.png`,
  timer_bg: `${folder}/buttons/timer_bg.png`,
  shop_banner_en: `${folder}/frames/shop_banner_en.png`,
  shop_banner_ja: `${folder}/frames/shop_banner_ja.png`,
  title_en: `${folder}/icons/gacha_title_en.png`,
  title_ja: `${folder}/icons/gacha_title_ja.png`,
  intro_bg: `${folder}/intro/bg.png`,
  intro_title_en: `${folder}/icons/gacha_title_en.png`,
  intro_title_ja: `${folder}/icons/gacha_title_ja.png`,
  intro_subtitle_en: `${folder}/icons/limitedtimeonly_en.png`,
  intro_subtitle_ja: `${folder}/icons/limitedtimeonly_jp.png`,
};

/** View styles for the  theme */
const styles: GachaThemeStyles = {
  gacha_popup: ({ width, height }) => ({
    width: downscale(1047),
    height: downscale(1389),
    x: width / 2,
    y: 690,
    image: assets.gacha_popup,
  }),
  gacha_popup_timer: () => ({
    color: '#A8896C',
  }),
  gacha_button_en: () => ({
    image: assets.gacha_button_en,
  }),
  gacha_button_ja: () => ({
    image: assets.gacha_button_ja,
  }),
  timer_bg: () => ({
    image: assets.timer_bg,
  }),
  shop_banner_en: () => ({
    width: downscale(813),
    height: downscale(255),
    image: assets.shop_banner_en,
  }),
  shop_banner_ja: () => ({
    width: downscale(813),
    height: downscale(255),
    image: assets.shop_banner_ja,
  }),
  title_en: () => ({
    y: 270,
    width: downscale(789),
    height: downscale(186),
    image: assets.title_en,
  }),
  title_ja: () => ({
    y: 270,
    width: downscale(564),
    height: downscale(233),
    image: assets.title_ja,
  }),
  intro_bg: ({ width, height }) => ({
    width: downscale(1080),
    height: downscale(1536),
    y: height * 0.1,
    image: assets.intro_bg,
  }),
  intro_title_en: ({ titleY }) => ({
    y: 126,
    width: downscale(789),
    height: downscale(186),
    image: assets.intro_title_en,
  }),
  intro_title_ja: ({ titleY }) => ({
    y: 126,
    width: downscale(564),
    height: downscale(233),
    image: assets.intro_title_ja,
  }),
  intro_subtitle_en: () => ({
    x: 111,
    y: 255,
    width: downscale(206),
    height: downscale(212),
    image: assets.intro_subtitle_en,
  }),
  intro_subtitle_ja: () => ({
    x: 111,
    y: 255,
    width: downscale(206),
    height: downscale(212),
    image: assets.intro_subtitle_ja,
  }),
  intro_timer: ({ titleY }) => ({
    y: 560,
  }),
  intro_text: ({ height }) => ({
    y: 692,
    scale: 0.8,
  }),
  intro_button: ({ height }) => ({
    y: 894,
  }),
};

export const gachaThemeSetsubun = {
  styles,
  assets,
  preload,
  folder,
};
